import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Tracking } from '../models/trackings';

type SliceModel = Tracking;
const sliceName: string = 'trackings';

const currRequests: Set<ModelId> = new Set;


export const fetchTrackings = createAsyncThunk(
    sliceName + '/fetchByDate',
    async (specs: { from: number, to: number; }) => {
        return await jsonGet<SliceModel[]>('/trackings/' + specs.from + '/' + specs.to);
    }
);

export const fetchTracking = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const trackingAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const trackingSlice = createSlice({
    name: sliceName,
    initialState: trackingAdapter.getInitialState(),
    reducers: {
        addMany: trackingAdapter.addMany,
        addOne: trackingAdapter.addOne,
        updateMany: trackingAdapter.updateMany,
        updateOne: trackingAdapter.updateOne,
        upsertOne: trackingAdapter.upsertOne,
        upsertMany: trackingAdapter.upsertMany,
        removeOne: trackingAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchTracking.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                trackingAdapter.upsertOne(state, action.payload);
            }
        });
        builder.addCase(fetchTrackings.fulfilled, (state, action) => {
            if (action.payload) {
                trackingAdapter.upsertMany(state, action.payload);
            }
        });

    },
});
